import { useData } from "./DataContext.js";

export default function VariableTitle (props)
{
    const gData = useData();

    if (props.icon === "only")
    {
	if (props.variableId === "investment" || props.variableId === "fund") return (<span>💰</span>);

	const variableContent = gData.content.variables[props.variableId];
	return (<span>{variableContent.icon}</span>);
    }
    
    if (props.variableId === "investment")
    {
	return (
	    <span>
		{props.icon === "start" && (<span>💰</span>)}
		<span className="text-uppercase">Investissements</span>
		{props.icon === "end" && (<span>💰</span>)}
	    </span>
	);
    }
    
    if (props.variableId === "fund")
    {
	return (
	    <span>
		{props.icon === "start" && (<span>💰</span>)}
		<span className="text-uppercase">Fonds</span>
		{props.icon === "end" && (<span>💰</span>)}		
	    </span>
	);
    }
    
    const variableContent = gData.content.variables[props.variableId];

    return (
	<span>
	    {props.icon === "start" && (<span>{variableContent.icon}</span>)}
	    <span className="text-uppercase">{variableContent.title}</span>
	    {props.icon === "end" && (<span>{variableContent.icon}</span>)}
	</span>
    );
}
